import axios from 'axios';

// Separate axios instance that bypasses the global interceptors
// (which attach Bearer tokens and redirect on 401)
const guestAxios = axios.create();

const GuestService = {
    heartbeat(roomUrl, sessionId, displayName) {
        return guestAxios
            .post('/vyu/guest/heartbeat', { roomUrl, sessionId, displayName })
            .then(({ data }) => data);
    },

    getImageBlob(roomUrl, filename) {
        return guestAxios
            .get(`/vyu/guest/room/${roomUrl}/presentation-item?filename=${encodeURIComponent(filename)}`, {
                responseType: 'blob'
            })
            .then(({ data }) => data);
    },

    leave(roomUrl, sessionId) {
        return guestAxios.post('/vyu/guest/leave', { sessionId }).catch(() => {});
    },

    getGuestInfo(roomUrl) {
        return guestAxios.get(`/vyu/guest/count/${roomUrl}`).then(({ data }) => data);
    }
};

export default GuestService;
